import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";
import Paystack from "@paystack/inline-js";
import axios from "axios";

function PlanCard({ plan, userSubscription, setUserSubscription }) {
  const infoElements = plan.planInfo.map((info) => <li key={info}>{info}</li>);
  const { user } = useContext(UserContext);
  const isSubscribed = userSubscription[plan.name];  

  const handlePayPlan = () => {
    const paystack = new Paystack();

    paystack.newTransaction({
      key: "pk_live_5690e1d858bc05ff4c259ae6e3c27f4066230e41",
      email: user?.email,
      firstName: user?.username.split(" ")[0] && "undifind",
      lastName: user?.username.split(" ")[0] && "undifind",
      currency: "GHS",
      amount: (plan.price * 12.67) * 100,
      phone: user?.phoneNumber,
      channels: [
        "card",
        "bank",
        "ussd",
        "qr",
        "eft",
        "mobile_money",
        "bank_transfer",
      ],

      onSuccess: (transaction) => {
        console.log(transaction);
        axios
          .put(`/auth/profile/${user?.id}`, { planTitle: plan.name })
          .then(({ data }) => {
            console.log(data.subscription, user.subscription);
            
            setUserSubscription(data.subscription);
            // console.log(user, userSubscription);
          })
          .catch((err) => {
            console.log(err);
          });
      },
      onLoad: (response) => {
        console.log("onLoad: ", response);
      },
      onCancel: () => {
        console.log("onCancel");
      },
      onError: (error) => {
        console.log("Error: ", error.message);
      },
    });
  };

  // useEffect(() => {
  //   axios.get(`/auth/profile/${user?.id}`).then(({data}) => {
  //     if (data) {
  //       setUserSubscription(data.subscription);
  //     }
  //   }).catch((err) => {
  //     console.log(err);
  //   })
  // }, []);

  return (
    <article className="plan_card">
      <div>
        <h3 id="plan_title">{plan.name}</h3>
        <ul>{infoElements}</ul>
      </div>

      <div>
        <h1>
          ${plan.price} <span>/{plan.duration}</span>
        </h1>
        <p>{plan.start}</p>

        {!user ? (
          <Link to={"/login"}>
            <button className="btn login">Pay now</button>
          </Link>
        ) : user && isSubscribed ? (
          <Link to={`/predictions/${plan.name.toLowerCase()}`}>
            <button className="btn login">View Plan</button>
          </Link>
        ) : (
          <button className="btn login" onClick={handlePayPlan}>
            Pay now
          </button>
        )}
      </div>
    </article>
  );
}

export default PlanCard;
